export default __webpack_public_path__ + "static/media/3.b365c9db.jpg";